// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e4df7d6a","239":"b7cee9c6","453":"63b0fa94","732":"e3d0a22b"}[chunkId] + ".chunk.js";
};